import { useMutation, useQueryClient } from '@tanstack/react-query';
import { packageServices } from '../services/package.service';
import toast from 'react-hot-toast';

export const useUpdatePackage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: packageServices.updatePackage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['packages'] });
      toast.success('Package updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update package');
    },
  });
};
